import { createReducer, on } from '@ngrx/store';
import { CategoryConfigurationInheritedApiActions } from './category-configuration-inherited.actions';
import { adapter, initialState } from './category-configuration-inherited.state';
import { CategoryConfigurationInheritanceStructureDto } from '@rocksoft/settings-sdk';

export const categoryConfigurationInheritedReducer = createReducer(
  initialState,
  on(CategoryConfigurationInheritedApiActions.categoryConfigurationInheritedLoaded, (state, { configuration }) => {
    // add the configuration to the store, keep calling addOne with the ancestor until we reach the top of the hierarchy
    let currentConfiguration: CategoryConfigurationInheritanceStructureDto | undefined = configuration;
    let newState = state;
    while (currentConfiguration) {
      newState = adapter.upsertOne(currentConfiguration, newState);
      currentConfiguration = currentConfiguration.ancestor;
    }
    return newState;
  })
);

const { selectAll } = adapter.getSelectors();

export const selectAllCategoryConfigurationInherited = selectAll;
